import { render, staticRenderFns } from "./Attendees.vue?vue&type=template&id=20766672&scoped=true&"
import script from "./Attendees.vue?vue&type=script&lang=js&"
export * from "./Attendees.vue?vue&type=script&lang=js&"
import style0 from "./Attendees.vue?vue&type=style&index=0&id=20766672&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20766672",
  null
  
)

component.options.__file = "Attendees.vue"
export default component.exports